import { connect } from 'react-redux';
import TradeDialog from './TradeDialog'
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { dialogActions } from '../../actions/dialog.actions';
import { phasePlanActions } from '../../actions/phaseplan.actions'
import { isTradeDialogOpen } from '../../selectors/dialog.selector'
import { getProjectUsersList, getProjectId } from '../../selectors/project.selector';
import { getTrade, getTradeId } from '../../selectors/phaseplan.selector';
import { alertActions } from '../../actions/alert.actions';
import { Trade } from '../../models/Trade';
import { ThunkDispatch } from 'redux-thunk';

const mapStateToProps = (state: any) => ({
    isTradeDialogOpen: isTradeDialogOpen(state),
    projectUsers: getProjectUsersList(state),
    projectId: getProjectId(state),
    tradeToEdit: getTrade(state),
    tradeToEditId: getTradeId(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => ({
    closeTradeDialogValue: () => dispatch(dialogActions.closeTradeDialog()),
    submitTradeValue: (trade: Trade, tradeId?: string) => dispatch(phasePlanActions.saveTrade(trade, tradeId)),
    errorAlert: (message: string) => dispatch(alertActions.error(message))

});


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true })
)(TradeDialog)


// WEBPACK FOOTER //
// ./src/components/Dialogs/TradeDialogContainer.tsx